export function isValidPhone(str: string) {
  return /^\(\d+\) \d{4,5}[- ]\d{4}$/.test(str)
}